import React,{useState, useContext} from 'react';
import { FirebaseContext } from '../../store/Contexts';
import Logo from '../../olx-logo.png';
import { useHistory, } from 'react-router-dom';
import './Login.css';

function Login() {
  const [email,setEmail]=useState('');
  const [password,setPassword]=useState('');
  const {firebase}=useContext(FirebaseContext);
  const history=useHistory();
  const handleLogin=(e)=>{
    e.preventDefault()
    firebase.auth().signInWithEmailAndPassword(email,password).then(()=>{
      alert('logged in ');
      history.push("/")

    }).catch((error)=>{
      alert(error.message)
    })

  }
  return (
    <div>
      <div className="loginParentDiv">
        <img width="200px" height="200px" src={Logo}></img>
        <form onSubmit={handleLogin}>
          <label htmlFor="fname">Email</label>
          <br />
          <input
            className="input"
            type="email"
            id="fname"
            name="email"
            onChange={(e)=>setEmail(e.target.value)}
           
          />
          <br />
          <label htmlFor="lname">Password</label>
          <br />
          <input
            className="input"
            type="password"
            id="password"
            name="password"
            onChange={(e)=>setPassword(e.target.value)}
            
          />
          <br />
          <br />
          <button >Login</button>
        </form>
        <a>Signup</a>
      </div>
    </div>
  );
}

export default Login;
